import { SearchInput } from '@/components/search-input'

import { useCapabilitiesForm } from './use-capabilities-form'

/** search across the 223 leaves + expand/collapse all + a live selected count. */
export function CapabilitiesToolbar() {
  const { state, derived, dispatch } = useCapabilitiesForm()

  return (
    <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
      <SearchInput
        value={state.query}
        onChange={query => dispatch({ type: 'setQuery', query })}
        placeholder='Search capabilities…'
        aria-label='Search capabilities'
        className='w-full sm:max-w-xs'
      />
      <div className='flex flex-wrap items-center gap-x-3 gap-y-1 text-[12px] text-ink-muted'>
        <span>
          {derived.selectedCount} selected
          {derived.incompleteCount > 0
            ? ` · ${derived.incompleteCount} need details`
            : ''}
        </span>
        <button
          type='button'
          onClick={() => dispatch({ type: 'setExpandedAll', expand: true })}
          className='-mx-2 inline-flex min-h-11 cursor-pointer items-center px-2 text-ink-soft hover:text-ink hover:underline sm:mx-0 sm:min-h-0 sm:px-0'
        >
          Expand all
        </button>
        <button
          type='button'
          onClick={() => dispatch({ type: 'setExpandedAll', expand: false })}
          className='-mx-2 inline-flex min-h-11 cursor-pointer items-center px-2 text-ink-soft hover:text-ink hover:underline sm:mx-0 sm:min-h-0 sm:px-0'
        >
          Collapse all
        </button>
      </div>
    </div>
  )
}
